import * as api from "@/api/configurations";
import { useLogin } from "@/hooks";
import { useQuery } from "react-query";

export function useLoginConfiguration() {
  return useQuery("configuration/login", api.getLoginConfiguration, {
    staleTime: Infinity,
  });
}

export function useConfiguration() {
  const { isLoggedIn } = useLogin();
  return useQuery("configuration", api.getConfiguration, {
    staleTime: Infinity,
    enabled: isLoggedIn,
  });
}
